(function () {
  'use strict';

  var EASE_OUT = 'cubic-bezier(0.23, 1, 0.32, 1)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initReveal(root) {
    var items = (root || document).querySelectorAll('[data-s-reveal]:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  function roll(container, text, direction) {
    if (!container) return;
    var span = container.querySelector('span') || container;
    if (span.textContent === text) return;
    if (reduceMotion.matches || !span.animate) {
      span.textContent = text;
      return;
    }
    var d = direction >= 0 ? 1 : -1;
    if (span._sAnim) span._sAnim.cancel();
    span._sAnim = span.animate(
      [{ transform: 'translateY(0)', opacity: 1 }, { transform: 'translateY(' + (-d * 70) + '%)', opacity: 0 }],
      { duration: 110, easing: EASE_OUT }
    );
    span._sAnim.onfinish = function () {
      span.textContent = text;
      span._sAnim = span.animate(
        [{ transform: 'translateY(' + (d * 70) + '%)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }],
        { duration: 190, easing: EASE_OUT }
      );
    };
  }

  function initModes(root) {
    (root || document).querySelectorAll('[data-s-modes]').forEach(function (block) {
      if (block._sReady) return;
      block._sReady = true;
      var buttons = block.querySelectorAll('[data-s-mode]');
      var digit = block.querySelector('[data-s-digit]');
      var detail = block.querySelector('[data-s-mode-detail]');
      var current = 1;
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var n = parseInt(btn.getAttribute('data-s-mode'), 10);
          if (n === current) return;
          var dir = n > current ? 1 : -1;
          current = n;
          buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          roll(digit, String(n), dir);
          if (detail) detail.textContent = btn.getAttribute('data-s-mode-text') || '';
        });
      });
    });
  }

  function formatMoney(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale || 'es-ES', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function initBuy(root) {
    (root || document).querySelectorAll('[data-s-buy]').forEach(function (form) {
      if (form._sReady) return;
      form._sReady = true;

      var cfg = {
        device: form.getAttribute('data-device-variant'),
        pads: form.getAttribute('data-pads-variant'),
        unit: parseInt(form.getAttribute('data-unit-price'), 10),
        pack: parseInt(form.getAttribute('data-pack-price'), 10),
        padsBundle: parseInt(form.getAttribute('data-pads-bundle-price'), 10),
        currency: form.getAttribute('data-currency'),
        locale: document.documentElement.lang || 'es',
        cartUrl: form.getAttribute('data-cart-url') || '/cart',
        addUrl: form.getAttribute('data-add-url') || '/cart/add.js'
      };
      var state = { qty: 1, pads: false };
      var total = form.querySelector('[data-s-total]');
      var submit = form.querySelector('[data-s-submit]');
      var error = form.querySelector('[data-s-error]');
      var qtyInputs = form.querySelectorAll('input[name="s-qty"]');
      var padsInput = form.querySelector('input[name="s-pads"]');

      function value() {
        var base = state.qty === 2 ? cfg.pack : cfg.unit;
        return base + (state.pads && cfg.pads ? cfg.padsBundle : 0);
      }

      function update(dir) {
        roll(total, formatMoney(value(), cfg.currency, cfg.locale), dir);
      }

      qtyInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          var next = parseInt(input.value, 10);
          var dir = next > state.qty ? 1 : -1;
          state.qty = next;
          update(dir);
        });
      });

      if (padsInput) {
        padsInput.addEventListener('change', function () {
          state.pads = padsInput.checked;
          update(state.pads ? 1 : -1);
        });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!submit || submit.getAttribute('aria-busy') === 'true') return;
        if (error) error.hidden = true;
        var items = [{ id: parseInt(cfg.device, 10), quantity: state.qty }];
        if (state.pads && cfg.pads) items.push({ id: parseInt(cfg.pads, 10), quantity: 1 });
        var label = submit.querySelector('[data-s-label]');
        var original = label ? label.textContent : '';
        submit.setAttribute('aria-busy', 'true');
        if (label) label.textContent = submit.getAttribute('data-busy-label') || original;

        fetch(cfg.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart');
            window.location.href = cfg.cartUrl;
          })
          .catch(function () {
            submit.setAttribute('aria-busy', 'false');
            if (label) label.textContent = original;
            if (error) error.hidden = false;
          });
      });
    });
  }

  function initGallery(root) {
    (root || document).querySelectorAll('[data-s-gallery]').forEach(function (g) {
      if (g._sReady) return;
      g._sReady = true;
      var track = g.querySelector('[data-s-track]');
      var thumbs = g.querySelectorAll('[data-s-thumb]');
      if (!track) return;
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          var slide = track.children[i];
          if (!slide) return;
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        });
      });
      if ('IntersectionObserver' in window && thumbs.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
              var idx = Array.prototype.indexOf.call(track.children, entry.target);
              thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
            }
          });
        }, { root: track, threshold: [0.6] });
        Array.prototype.forEach.call(track.children, function (s) { io.observe(s); });
      }
    });
  }

  function init(root) {
    initReveal(root);
    initModes(root);
    initBuy(root);
    initGallery(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
